import React from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import { printDocs } from '../utils/printDocs';

// Печать моего паспорта из «Мои документы» (документы с «паспорт» в названии); не загружен — переход на страницу
export default function MyPassportButton({ className = 'btn btn-secondary btn-sm' }) {
  const navigate = useNavigate();
  const go = async () => {
    try {
      const { data } = await api.get('/my-docs');
      const p = data.filter(d => /паспорт/i.test(d.title));
      if (p.length) printDocs(p);
      else if (window.confirm('Паспорт ещё не загружен. Открыть «Мои документы»?')) navigate('/my-docs');
    } catch { navigate('/my-docs'); }
  };
  return <button className={className} onClick={go} title="Печать моего паспорта (Справочники → Мои документы)">🖨 Мой паспорт</button>;
}
